<script>
import ChildParentRelationsRepository from '../../js/repository/ChildParentRelationsRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ChildParentRelationsRepository.findAll,
                params: [this.childId],
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
